import { ComponentPropsWithoutRef } from "react";
import { SectionCardCarousel as ISectionCardCarousel } from "~/sanity/types";
import * as styles from "./SectionCardCarousel.css";
import { BlockCardCarousel } from "~/components/components/blocks/BlockCardCarousel";
import { WrapperContentMask } from "~/components/wrappers/WrapperContentMask";

export type SectionCardCarouselProps = ComponentPropsWithoutRef<"div"> & {
  data: any;
  layout?: "small" | "default";
  theme?: "colour" | "light";
};

export const SectionCardCarousel = ({
  data,
  layout = "default",
  children,
  theme = "colour",
  ...props
}: SectionCardCarouselProps) => {
  const carousel = (
    <div className={styles.carousel}>
      <BlockCardCarousel
        theme={theme}
        title={data.title}
        text={data.text}
        link={data.link}
        layout={layout}
      >
        {children}
      </BlockCardCarousel>
    </div>
  );

  return (
    <section className={styles.section} {...props}>
      <WrapperContentMask className={styles.wrapper({ theme: theme })}>
        {carousel}
      </WrapperContentMask>
    </section>
  );
};
